import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-proof-of-insurance',
    templateUrl: './proof-of-insurance.component.html',
    styleUrls: ['./proof-of-insurance.component.scss'],
    standalone: false
})
export class ProofOfInsuranceComponent implements OnInit {
  @Input() propertyProtectionLabel = '';
  @Input() POIData = null;
  @Input() defaultDate = null;
  @Input() FacilityMoveInSettings = null;
  @Output() emitSavedPOI: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitClosePOI: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('PropertyProtectionPolicy', { static: true }) PropertyProtectionPolicy: TemplateRef<any>;

  minDate;
  expEndDate;
  PolicyNumber = '';
  InsCompanyName = '';
  ExpiryDate = '';

  constructor() { }

  ngOnInit(): void {
  }

  disableSave() {
    if (this.PolicyNumber?.trim() !== '' && this.InsCompanyName?.trim() !== '' && this.ExpiryDate) { // rental, transfer
      return false;
    } else {
      return true;
    }
  }

  saveProofOfInsurance() {
    let dataObj = {
      PolicyNumber: this.PolicyNumber,
      InsCompanyName: this.InsCompanyName,
      ExpiryDate: this.ExpiryDate
    }
    this.emitSavedPOI.emit(dataObj);
  }

  ClosePOIPopUp() {
    this.emitClosePOI.emit(true);
  }

  clearFields() {
    this.PolicyNumber = null;
    this.ExpiryDate = null;
    this.InsCompanyName = null;
  }

  setInitialDetails() {
    if (this.POIData) {
      this.PolicyNumber = this.POIData.PolicyNumber;
      this.ExpiryDate = this.POIData.ExpiryDate;
      this.InsCompanyName = this.POIData.InsCompanyName;
    }
    const date = new Date(this.defaultDate);
    date.setHours(0, 0, 0, 0);
    this.minDate = date;
    const offset = date.getTimezoneOffset() * 60 * 1000;
    this.expEndDate = new Date(date.getTime() + offset +
      (this.FacilityMoveInSettings.FutureDaysAllowedForExpiry + 1) * 24 * 60 * 60 * 1000);
  }
}
